<template>
  <div class="headerBg">
    <header class="float-start w-100">
      <div class="top-header01">

        <nav class="navbar navbar-expand-lg navbar-light">
          <div class="container">
            <router-link class="navbar-brand" to="/login">
              <img alt="sr" src="static/static/picture/logo.png">
            </router-link>
            <div class="right-menu-rd d-flex d-lg-none">

              <div class="d-flex align-items-center">
                <!-- <el-dropdown> -->
                <!-- <el-dropdown trigger="click" v-if="userInfo.pic">
                  <span class="el-dropdown-link">
                    <el-avatar :size="40" :src="userInfo.pic" @error="() => true">
                      <img src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" />
                    </el-avatar>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>黄金糕</el-dropdown-item>
                    <el-dropdown-item>狮子头</el-dropdown-item>
                    <el-dropdown-item>螺蛳粉</el-dropdown-item>
                    <el-dropdown-item disabled>双皮奶</el-dropdown-item>
                    <el-dropdown-item divided>蚵仔煎</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <template v-else>
                  <a data-bs-toggle="modal" data-bs-target="#loginModal"
                    class="btn btn-login d-none d-sm-inline-block d-lg-none">
                    登录
                  </a>
                  <a data-bs-toggle="modal" data-bs-target="#registerModal" class="btn btn-partners ms-3">立即开始</a>
                </template> -->
                <a data-bs-toggle="modal" data-bs-target="#loginModal"
                  class="btn btn-login d-none d-sm-inline-block d-lg-none">
                  登录
                </a>
                <a data-bs-toggle="modal" data-bs-target="#registerModal" class="btn btn-partners ms-3">立即开始</a>
              </div>
              <button class="navbar-toggler border-0 p-0 ms-4" type="button" data-bs-toggle="offcanvas"
                data-bs-target="#mobile-menu">
                <i class="fas fa-bars"></i>
              </button>
            </div>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
                <li class="nav-item">
                  <router-link class="nav-link" to="/login">HOME</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/about">关于我们</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/case">案例</router-link>
                </li>

                <li class="nav-item">
                  <router-link class="nav-link" to="/feature">特色</router-link>
                </li>

                <li class="nav-item">
                  <router-link class="nav-link" to="/price">价格</router-link>
                </li>

                <li class="nav-item">
                  <router-link class="nav-link" to="/contact">联系我们</router-link>
                </li>

              </ul>

            </div>


            <div class="right-menu-rd d-none d-lg-block">
              <!-- <el-dropdown v-if="userInfo.pic">
                <span class="el-dropdown-link">
                  <el-avatar :size="40" :src="userInfo.pic" @error="() => true">
                    <img src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" />
                  </el-avatar>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>黄金糕</el-dropdown-item>
                  <el-dropdown-item>狮子头</el-dropdown-item>
                  <el-dropdown-item>螺蛳粉</el-dropdown-item>
                  <el-dropdown-item disabled>双皮奶</el-dropdown-item>
                  <el-dropdown-item divided>蚵仔煎</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
              <!-- <ul v-else class="solinu-links d-flex align-items-center"> -->
                <ul class="solinu-links d-flex align-items-center">

                <li>
                  <a data-bs-toggle="modal" data-bs-target="#loginModal" class="btn btn-login mx-3">登录</a>
                </li>

                <li>
                  <a data-bs-toggle="modal" data-bs-target="#registerModal" class="btn btn-partners">立即开始</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>

    </header>
    <!-- mobile menu -->
    <div class="offcanvas offcanvas-end mobile-menu-div" id="mobile-menu">
      <div class="offcanvas-header">

        <button type="button" class="close-menu closeBtn" data-bs-dismiss="offcanvas">
          <svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 16 16">
            <path
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z">
            </path>
          </svg>
        </button>
      </div>

      <div class="offcanvas-body">

        <div class="head-contact">
          <router-link to="/login" class="logo-side">
            <img src="static/static/picture/logo.png" alt="logo">
          </router-link>
          <div class="mobile-menu-sec mt-3">
            <ul class="list-unstyled">
              <li v-for="item in pathList" :key="item.path" :class="[item.path === lightNav ? 'active-m' : '']">
                <router-link :to="item.path">{{ item.name }}</router-link>
              </li>
            </ul>
          </div>

          <!-- <ul class="side-media list-unstyled">
          <li> <a href="#"> <i class="fab fa-facebook-f"></i> </a> </li>
          <li> <a href="#"> <i class="fab fa-twitter"></i> </a> </li>
          <li> <a href="#"> <i class="fab fa-google-plus-g"></i> </a> </li>
          <li> <a href="#"> <i class="fab fa-instagram"></i> </a> </li>
        </ul> -->
        </div>
      </div>

    </div>

    <!-- 登录 -->
    <div class="modal fade login-div-modal" id="loginModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
          </div>
          <div class="modal-body">

            <div id="login-td-div" class="com-div-md">

              <h5 class="text-center mb-3"> 登录 </h5>
              <button type="button" class="close mCloseImg" data-bs-dismiss="modal">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x"
                  viewbox="0 0 16 16">
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z">
                  </path>
                </svg>
              </button>
              <div class="login-modal-pn">

                <el-form ref="loginForm" :model="loginForm" :rules="rules" label-width="0px">
                  <el-form-item prop="user">
                    <div class="country-dp">
                      <input v-model="loginForm.user" class="form-control" placeholder="请输入用户名">
                    </div>
                  </el-form-item>
                  <el-form-item prop="password">
                    <div class="country-dp">
                      <input
                        type="password"
                        v-model="loginForm.password"
                        class="form-control"
                        placeholder="请输入密码"
                        @keyup.enter="submitLogin"
                      >
                    </div>
                  </el-form-item>
                  <el-form-item prop="agree">
                    <div class="checkDeal">
                      <input v-model="loginForm.agree" type="checkbox" class="form-check-input" id="exampleCheck1">
                      <label class="form-check-label checkP" for="exampleCheck1">
                        阅读并接受
                        <span style="color: #409eff" @click="toAgreement(1)">《用户协议》</span>
                        及
                        <span style="color: #409eff" @click="toAgreement(2)">《隐私权保护声明》</span>
                      </label>
                    </div>
                  </el-form-item>
                </el-form>
                <el-button type="primary" @click="submitLogin" class="btn continue-bn" :loading="loading">
                  <i class="fas fa-lock"></i> 登录
                </el-button>
              </div>
              <p class="text-center  mt-3">
                <a data-bs-toggle="modal" class="regster-bn" data-bs-target="#lostpsModal" data-bs-dismiss="modal"> 忘记密码
                  ? </a>
              </p>
              <p class="text-center  mt-3"> 没有账号?
                <a data-bs-toggle="modal" class="regster-bn" data-bs-target="#registerModal" data-bs-dismiss="modal"> 注册
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 注册 -->
    <div class="modal fade login-div-modal" id="registerModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="com-div-md">

              <h5 class="text-center mb-3">免费注册</h5>
              <button type="button" class="close mCloseImg" data-bs-dismiss="modal">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x"
                  viewbox="0 0 16 16">
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z">
                  </path>
                </svg>
              </button>
              <div class="login-modal-pn">
                <el-form ref="registerForm" :model="registerForm" :rules="rules" label-width="0px">
                  <el-form-item prop="user">
                    <input v-model="registerForm.user" class="form-control" placeholder="请输入用户名">
                  </el-form-item>
                  <el-form-item prop="phone">
                    <input v-model="registerForm.phone" class="form-control" placeholder="请输入手机号码">
                  </el-form-item>
                  <el-form-item prop="password">
                    <input type="password" v-model="registerForm.password" class="form-control" placeholder="请输入密码">
                  </el-form-item>
                  <el-form-item prop="verificationCode">
                    <div class="code-div" style="display: flex; flex-direction: row;">
                      <div style=" flex: 1;">
                        <input v-model="registerForm.verificationCode" class="form-control" placeholder="请输入验证码">
                      </div>
                      <div style="width: 90px; margin-left: 10px;">
                        <el-button :disabled="formToCodeLoad.registerForm.disabled" type="primary"
                          @click="getVerificationCode('registerForm')" class="btn continue-bn">
                          {{ formToCodeLoad.registerForm.disabled ? `${formToCodeLoad.registerForm.countDown}s` : '获取验证码'
                          }}
                        </el-button>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <input v-model="registerForm.inviteCode" class="form-control" placeholder="请输入邀请码（选填）">
                  </el-form-item>
                  <el-form-item prop="agree">
                    <div class="checkDeal">
                      <input v-model="registerForm.agree" type="checkbox" class="form-check-input" id="exampleCheck1">
                      <label class="form-check-label checkP" for="exampleCheck1">
                        阅读并接受
                        <span style="color: #409eff" @click="toAgreement(1)">《用户协议》</span>
                        及
                        <span style="color: #409eff" @click="toAgreement(2)">《隐私权保护声明》</span>
                      </label>
                    </div>
                  </el-form-item>
                </el-form>
                <el-button type="primary" @click="submitRegister" class="btn continue-bn"> 注册 </el-button>
              </div>

              <p class="text-center  mt-3"> 已有账号?
                <a data-bs-toggle="modal" class="regster-bn" data-bs-target="#loginModal" data-bs-dismiss="modal"> 登录
                </a>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 忘记密码 -->
    <div class="modal fade login-div-modal" id="lostpsModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="com-div-md">
              <h5 class="text-center mb-3"> 忘记密码? </h5>
              <button type="button" class="close mCloseImg" data-bs-dismiss="modal">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x"
                  viewbox="0 0 16 16">
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z">
                  </path>
                </svg>
              </button>
              <div class="login-modal-pn">

                <el-form ref="resetForm" :model="resetForm" :rules="rules" label-width="0px">

                  <el-form-item prop="phone">
                    <input v-model="resetForm.phone" class="form-control" placeholder="请输入手机号码">
                  </el-form-item>
                  <el-form-item prop="verificationCode">
                    <div class="code-div" style="display: flex; flex-direction: row;">
                      <div style=" flex: 1;">
                        <input v-model="resetForm.verificationCode" class="form-control" placeholder="请输入验证码">
                      </div>
                      <div style="width: 90px; margin-left: 10px;">
                        <el-button :disabled="formToCodeLoad.resetForm.disabled" type="primary"
                          @click="getVerificationCode('resetForm')" class="btn continue-bn">
                          {{ formToCodeLoad.resetForm.disabled ? `${formToCodeLoad.resetForm.countDown}s` : '获取验证码' }}
                        </el-button>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item prop="password">
                    <input
                      type="password"
                      v-model="resetForm.password"
                      class="form-control"
                      placeholder="请输入密码"
                      @keyup.enter="submitForgetPwd"
                    >
                  </el-form-item>
                </el-form>
                <button @click="submitForgetPwd" class="btn continue-bn"> 确定 </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import api from "@/api";
import util from "@/utils/utils";
export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      console.log(rule, value);
      if (!value) {
        callback(new Error('请输入手机号'));
      } else {
        const reg = /^\d{11}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('手机号格式错误'));
        }
      }
    }
    return {
      login: api.get_session,
      register: api.Register,
      sendCode: api.SendCode,
      getUserInfo: api.getUserInfo,
      GetOpenAIAccount: api.GetOpenAIAccount,
      forgetPwd: api.ForgetPwd,
      user_account_key: "user_account",
      openAIAccount: {},
      lightNav: '', // 当前选中的侧边菜单
      loading: '', // 页面loading效果
      userInfo: {
        name: '',
        pic: '',
        // pic: 'https://q4.itc.cn/q_70/images03/20240405/39ec09deda3a41d79e03897b0fdf68a0.jpeg',
      },
      // 验证码按钮loading效果
      formToCodeLoad: {
        registerForm: {
          disabled: false,
          countDown: 60,
          timer: '',
        },
        resetForm: {
          disabled: false,
          countDown: 60,
          timer: '',
        },
      },
      loginForm: {
        user: '',
        password: '',
        agree: []
      },
      resetForm: {
        phone: '',
        verificationCode: '',
        password: ''
      },
      registerForm: {
        user: '',
        phone: '',
        password: '',
        verificationCode: '',
        inviteCode: '',
        agree: []
      },
      rules: {
        user: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        phone: [{ validator: validatePhone, trigger: ['blur', 'change'] }],
        verificationCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        agree: [
          { type: 'array', required: true, message: '请同意《用户协议》和《隐私权保护声明》协议', trigger: 'change' }
        ],
      },
      pathList: [
        {
          path: '/login',
          name: 'HOME',
        },
        {
          path: '/about',
          name: '关于我们',
        },
        {
          path: '/case',
          name: '案例',
        },
        {
          path: '/feature',
          name: '特色',
        },
        {
          path: '/price',
          name: '价格',
        },
        {
          path: '/contact',
          name: '联系我们',
        },
      ]
    }
  },
  methods: {
    // 获取OpenAI账户
    toGetOpenAIAccount() {
      this.loading = true;
      this.GetOpenAIAccount({
        userId: 0,
      })
        .then((res) => {
          if (res.success) {
            //debugger
            this.openAIAccount = res.data;
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    // 读取邀请码
    readCode() {
      //读取地址栏邀请码
      var code = util.getQueryString("code");
      const regex = /^10\d{4}$/;
      if (regex.test(code)) {
        this.registerForm.inviteCode = code;
      }
    },
    // 查看协议
    toAgreement(type) {
      if (type === 1) {
        window.open("/用户协议.pdf");
      }
      if (type === 2) {
        window.open("/隐私权保护申明.pdf");
      }
    },
    // 登录
    submitLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const { user, password } = this.loginForm;
          this.login({ account: user, pwd: password })
            .then((res) => {
              if (res.success) {
                localStorage.setItem("temp_login", JSON.stringify(res));
                localStorage.setItem(this.user_account_key, user);
                $('#loginModal').modal('hide');
                this.$router.push("/");
              } else {
                var msgs = util.getMsgs(res);
                var errmsg = msgs.join(",");
                this.$message.error("登录失败：" + errmsg);
              }
              this.loading = false;
            })
            .catch((e) => {
              this.$message.error("登录出错：" + e.toString());
              this.loading = false
            });
        }
      })
    },
    // 注册
    submitRegister() {
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          const { user, password, phone, verificationCode, inviteCode } =
            this.registerForm;
          this.loading = true;
          this.register({
            account: user,
            pwd: password,
            phone: phone,
            code: verificationCode,
            promoCode: inviteCode,
          })
            .then((res) => {
              if (res.success) {
                localStorage.setItem("temp_login", JSON.stringify(res));
                //this.$emit("onLoginOk", res);
                this.$message({
                  message: "注册成功！",
                  type: "success",
                });
                $('#registerModal').modal('hide');
                this.$router.push("/");
              } else {
                var msgs = util.getMsgs(res);
                var errmsg = msgs.join(",");
                this.$message.error("注册失败：" + errmsg);
              }
              this.loading = false;
            })
            .catch((e) => {
              this.$message.error("注册出错：" + e.toString());
              this.loading = false;
            });
        }
      });
    },
    // 忘记密码
    submitForgetPwd() {
      this.$refs.resetForm.validate(async (valid) => {
        if (valid) {
          const { password, phone, verificationCode } = this.resetForm;
          this.loading = true;
          this.forgetPwd({
            pwd: password,
            phone: phone,
            code: verificationCode,
          })
            .then((res) => {
              if (res.success) {
                this.loginForm.user = this.resetForm.phone;
                $('#lostpsModal').modal('hide');
                this.$message({
                  message: "修改成功！",
                  type: "success",
                });
              } else {
                var msgs = util.getMsgs(res);
                var errmsg = msgs.join(",");
                this.$message.error("提交失败：" + errmsg);
              }
              this.loading = false;
            })
            .catch((e) => {
              this.$message.error("提交出错：" + e.toString());
              this.loading = false;
            });
        }
      });
    },
    // 获取验证码
    getVerificationCode(formName) {
      this.$refs[formName].validateField('phone', (err) => {
        console.log(err);
        if (!err) {
          this.loading = true;
          const { phone } = this[formName];
          this.sendCode({
            phone: phone,
            type: formName === 'resetForm' ? 2 : 1,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "发送成功！",
                  type: "success",
                });

                const formMsg = this.formToCodeLoad[formName];
                formMsg.disabled = true;
                formMsg.timer = setInterval(() => {
                  formMsg.countDown--;
                  if (formMsg.countDown === 0) {
                    clearInterval(formMsg.timer);
                    formMsg.countDown = 60;
                    formMsg.disabled = false;
                  }
                }, 1000);
              } else {
                var msgs = util.getMsgs(res);
                var errmsg = msgs.join(",");
                this.$message.error("发送失败：" + errmsg);
              }
              this.loading = false;
            })
            .catch((e) => {
              this.$message.error("发送出错：" + e.toString());
              this.loading = false;
            });
        }
      })
    },
  },
  watch: {
    '$route.path': {
      handler(to) {
        this.lightNav = to;
        $('#mobile-menu').offcanvas('hide');
      },
      immediate: true,
    }
  },
  mounted() {
    // this.lightNav = this.$route.path;
  },
  created() {
    this.readCode();
    if (localStorage.getItem(this.user_account_key)) {
      this.loginForm.user = localStorage.getItem(this.user_account_key);
    }

    this.toGetOpenAIAccount();
  },
}
</script>
  
<style scoped lang="less">
.headerBg {
  height: 100px;
  width: 100%;
  background: transparent;
  margin-bottom: -100px;

  .offcanvas-end {
    width: 60%;
  }

  .nav-link:focus{
    color: #fff !important;
  }

  .closeBtn {
    svg {
      padding: 8px 0 0 8px;
      transform: scale(1.875);
    }
  }

  .mCloseImg {
    svg {
      transform: scale(1.5);
      padding: 4px 0 0 4px;
    }
  }

  .form-control {
    // .el-form-item {
    margin-bottom: 0;
  }

  .el-checkbox {
    font-weight: 600;
    color: black;
  }

  .checkDeal {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // margin-top: -8px;
    // margin-bottom: -10px;

    .checkP {
      // margin-bottom: 15px;
      margin-left: 10px;
      font-weight: 600;
      font-size: 14px;
      width: 92%;
      line-height: 21px;
    }
  }

  .el-button--primary {
    background: #452ff4;
    border-color: #452ff4;
    padding: 4px 8px;
    line-height: 31px;
    font-weight: 700;
    // font-size: 11px;
    font-size: 1rem;
  }

  .form-check-input {
    margin-top: 0;
  }
}</style>